/*import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
*/
import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import DOMPurify from 'dompurify';

@Pipe({
	name: 'safeUrl'
	//name: 'safeHtml'
})
export class SafeUrlPipe implements PipeTransform {

	constructor(private domSanitizer: DomSanitizer) { }

	transform(value: string, url: string = ''): any {
		return this.domSanitizer.bypassSecurityTrustResourceUrl(url + value);
		//const sanitizedContent = DOMPurify.sanitize(value);
		//return this.domSanitizer.bypassSecurityTrustHtml(value);


	}

}
